"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRequestDto = instanceOfShiftRequestDto;
exports.ShiftRequestDtoFromJSON = ShiftRequestDtoFromJSON;
exports.ShiftRequestDtoFromJSONTyped = ShiftRequestDtoFromJSONTyped;
exports.ShiftRequestDtoToJSON = ShiftRequestDtoToJSON;
exports.ShiftRequestDtoToJSONTyped = ShiftRequestDtoToJSONTyped;
const NurseProfileDto_1 = require("./NurseProfileDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const ShiftProposalDto_1 = require("./ShiftProposalDto");
const RequestedBy_1 = require("./RequestedBy");
/**
 * Check if a given object implements the ShiftRequestDto interface.
 */
function instanceOfShiftRequestDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function ShiftRequestDtoFromJSON(json) {
    return ShiftRequestDtoFromJSONTyped(json, false);
}
function ShiftRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['status']),
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoFromJSON)(json['nurseProfile']),
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'requestedByProfile': json['requestedByProfile'] == null ? undefined : json['requestedByProfile'],
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'nurseHasSpecialty': json['nurseHasSpecialty'] == null ? undefined : json['nurseHasSpecialty'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'proposal': json['proposal'] == null ? undefined : (0, ShiftProposalDto_1.ShiftProposalDtoFromJSON)(json['proposal']),
    };
}
function ShiftRequestDtoToJSON(json) {
    return ShiftRequestDtoToJSONTyped(json, false);
}
function ShiftRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['status']),
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoToJSON)(value['nurseProfile']),
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'requestedByProfile': value['requestedByProfile'],
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'nurseHasSpecialty': value['nurseHasSpecialty'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'proposal': (0, ShiftProposalDto_1.ShiftProposalDtoToJSON)(value['proposal']),
    };
}
//# sourceMappingURL=ShiftRequestDto.js.map